import axios from 'axios'

export default {
    request({url, body, type, resolve, reject, token, hideErrorMessage = false}) {
        const api = axios.create()
        let request

        // auth interceptor start
        api.interceptors.request.use(request => {
            request.headers['Content-Type'] = 'application/json'
            request.headers.Authorization = `Bearer ${token}`

            return request
        })

        api.interceptors.response.use(
            response => {
                return response
            },
            error => {
                const originalRequest = error.config

                if (!hideErrorMessage) {
                    if (error.response) console.log("Message: " + JSON.stringify(error.response));
                }

                return Promise.reject(error)
            }
        )
        // auth interceptor end

        if (type === 'GET') request = api.get(url, body)
        else if (type === 'DEL') request = api.delete(url, body)
        else if (type === 'PUT') request = api.put(url, body)
        else if (type === 'PATCH') request = api.patch(url, body)
        else request = api.post(url, body)

        if (resolve && reject) {
            request
                .then(response => {
                    resolve(response)
                })
                .catch(e => {
                    reject(e)
                })
        } else {
            return request
        }
    }
}


// WEBPACK FOOTER //
// ./resources/vue/service/index.js